var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDatabase = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 19,
  viewBox: "0 0 19 19",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  transform: "matrix(.84874 0 0 .84874 .136 .142)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 11,
  cy: 4,
  rx: 9,
  ry: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 4v14a9 3 0 0 0 18 0V4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 11a9 3 0 0 0 18 0"
}))));
export { SvgDatabase as ReactComponent };
export default __webpack_public_path__ + "assets/images/database.svg";